export const apiEndpoint = process.env.GATSBY_REST_ENDPOINT
